/* Load CSS or JS assets dynamically to the DOM with option to call a function upon successful loading
* asset: string or array of strings to load and append to head of DOM
* callback: [function] (optional) Function to be called when all [assets] have been loaded
*/
export const loadAsset = (asset, callback, config = { location: '', returnAsset: false }) => {
  // Checks if a callback has been passed to the loadAsset method.
  const hasCallBack = arguments.length >= 2
  let currentAssetType = ''
  const assetTypes = []

  const getAssetExtension = assetItem => {
    const urlQueryIndex = assetItem.indexOf('?')
    const endOfStringIndex = urlQueryIndex > -1 ? urlQueryIndex : assetItem.length
    const assetExtension = assetItem.substring(0, endOfStringIndex).split('.').pop()
    assetTypes.push(assetExtension)

    return assetExtension
  }

  // Checks if the asset already exists on the DOM
  function isElementInDom(assetItem) {
    const getElementsInHead = [].slice.call(document.head.getElementsByTagName(currentAssetType === 'js' ? 'script' : 'link'))

    return getElementsInHead.some(item => {
      if (item.attributes.src && item.attributes.src.value === assetItem) {
        console.info(`${assetItem} already loaded`)
        return true
      }
      return false
    })
  }

  function createAsset(assetItem) {
    let newAsset

    switch (currentAssetType) {
      case 'js':
        newAsset = document.createElement('script')
        newAsset.type = 'text/javascript'
        newAsset.src = assetItem

        if (hasCallBack) {
          newAsset.onload = callback
          newAsset.onreadystatechange = callback
        }
        break

      case 'css':
        newAsset = document.createElement('link')
        newAsset.type = 'text/css'
        newAsset.href = assetItem
        newAsset.rel = 'stylesheet'
        break

      default:
        throw Error(`${assetItem} is not a valid asset. It must be either a "js" or "css" file.`)
    }
    return newAsset
  }

  // Adds asset to the DOM
  function appendAsset(assetItem) {
    let location = null

    if (config.location === 'body') {
      location = document.body
    } else {
      location = document.getElementsByTagName('head')[0] // eslint-disable-line
    }

    /* Set the closure variable */
    currentAssetType = getAssetExtension(assetItem)

    if (!isElementInDom(assetItem)) {
      location.appendChild(createAsset(assetItem))
    }
  }

  try {
    if (!asset) {
      throw Error('Missing parameter, please include a string URL as the first param to this function.')
    } else if (Array.isArray(asset)) { // If an array of assets is passed, loop through assets
      asset.forEach(item => {
        appendAsset(item)
      })
    } else {
      appendAsset(asset)
    }
    // Only execute callback if a css asset has been appendeassetTypesd and there IS a callback. JS callback is handled within the createAsset method.
    if (arguments.length === 2 && assetTypes.indexOf('css') > -1) {
      callback()
    }
  } catch (e) {
    console.error(`unable to append asset to DOM. ${e}`)
  }
}
export { isEmpty } from './isEmpty'
export { creditcardDetector } from './creditcardDetector'
export { leftPad } from './leftPad'
export { nofitySfChat } from './postMessage'
export { injectScript } from './injectScript'
export * from './requests'
export * from './cookies'
export * from './global'
export * from './sharedStyles'



// WEBPACK FOOTER //
// ./src/utils/index.js